export class HighmapsService {

	getCountyData() {
		return {
            "title": "",
            "version": "1.0.0",
            "type": "FeatureCollection",
            "copyright": "Copyright (c) 2014 Highsoft AS, Based on data from The United States Census Bureau http://www.census.gov",
            "copyrightShort": "USA Census Bureau",
            "copyrightUrl": "http://www.census.gov",
            "crs": {
                "type": "name",
                "properties": {
                    "name": "urn:ogc:def:crs:EPSG:2260"
                }
            }
            ,
            "features": [{
                "type": "Feature",
                "id": "US.NY.007",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.36, "hc-middle-y": 0.69, "hc-key": "us-ny-007", "hc-a2": "BR", "name": "Broome", "code": "36007"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[970, 961], [886, 962], [806, 964], [804, 1019], [811, 1019], [812, 1032], [806, 1058], [806, 1072], [803, 1085], [826, 1084], [861, 1086], [865, 1040], [870, 1036], [910, 1036], [910, 1020], [958, 1019], [956, 974], [961, 965], [970, 961]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.015",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "us-ny-015", "hc-a2": "CH", "name": "Chemung", "code": "36015"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[695, 1050], [703, 1050], [712, 1049], [712, 1012], [706, 1012], [710, 981], [706, 966], [645, 968], [616, 969], [616, 976], [619, 1051], [619, 1053], [646, 1054], [669, 1054], [669, 1040], [680, 1040], [689, 1035], [694, 1040], [695, 1050]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.017",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.49, "hc-middle-y": 0.50, "hc-key": "us-ny-017", "hc-a2": "CH", "name": "Chenango", "code": "36017"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[959, 1054], [958, 1036], [958, 1019], [910, 1020], [910, 1036], [870, 1036], [865, 1040], [861, 1086], [860, 1109], [857, 1177], [957, 1182], [957, 1180], [986, 1181], [986, 1174], [978, 1160], [979, 1135], [970, 1125], [962, 1103], [968, 1083], [961, 1074], [963, 1066], [959, 1054]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.023",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.49, "hc-middle-y": 0.51, "hc-key": "us-ny-023", "hc-a2": "CO", "name": "Cortland", "code": "36023"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[856, 1197], [856, 1192], [857, 1177], [860, 1109], [861, 1086], [826, 1084], [803, 1085], [776, 1085], [776, 1085], [775, 1110], [774, 1149], [773, 1186], [773, 1192], [815, 1194], [856, 1197]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.025",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.47, "hc-middle-y": 0.43, "hc-key": "us-ny-025", "hc-a2": "DE", "name": "Delaware", "code": "36025"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[958, 1019], [958, 1036], [959, 1054], [983, 1057], [993, 1070], [1007, 1067], [1029, 1085], [1046, 1088], [1059, 1098], [1084, 1112], [1100, 1110], [1113, 1114], [1113, 1114], [1113, 1114], [1133, 1086], [1172, 1065], [1175, 1064], [1151, 1020], [1170, 1011], [1158, 1003], [1153, 1004], [1148, 996], [1098, 965], [1068, 948], [1017, 917], [1010, 923], [1000, 919], [992, 921], [990, 934], [984, 948], [981, 946], [970, 961], [961, 965], [956, 974], [958, 1019]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.077",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.52, "hc-middle-y": 0.39, "hc-key": "us-ny-077", "hc-a2": "OT", "name": "Otsego", "code": "36077"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[986, 1181], [996, 1193], [999, 1208], [997, 1219], [998, 1221], [1005, 1221], [1005, 1214], [1020, 1215], [1029, 1229], [1071, 1204], [1074, 1207], [1077, 1226], [1102, 1216], [1114, 1211], [1127, 1206], [1123, 1182], [1131, 1146], [1113, 1114], [1113, 1114], [1113, 1114], [1100, 1110], [1084, 1112], [1059, 1098], [1046, 1088], [1029, 1085], [1007, 1067], [993, 1070], [983, 1057], [959, 1054], [963, 1066], [961, 1074], [968, 1083], [962, 1103], [970, 1125], [979, 1135], [978, 1160], [986, 1174], [986, 1181]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.097",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "us-ny-097", "hc-a2": "SC", "name": "Schuyler", "code": "36097"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[619, 1051], [589, 1050], [589, 1112], [615, 1112], [615, 1105], [637, 1105], [635, 1114], [636, 1128], [663, 1128], [680, 1128], [681, 1078], [679, 1051], [695, 1050], [694, 1040], [689, 1035], [680, 1040], [669, 1040], [669, 1054], [646, 1054], [619, 1053], [619, 1051]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.101",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.51, "hc-middle-y": 0.50, "hc-key": "us-ny-101", "hc-a2": "ST", "name": "Steuben", "code": "36101"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[506, 1143], [516, 1142], [534, 1141], [582, 1140], [580, 1117], [589, 1119], [589, 1112], [589, 1050], [619, 1051], [616, 976], [616, 969], [581, 969], [443, 974], [452, 1093], [455, 1113], [456, 1132], [469, 1131], [470, 1145], [506, 1143]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.107",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.69, "hc-key": "us-ny-107", "hc-a2": "TI", "name": "Tioga", "code": "36107"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[803, 1085], [806, 1072], [806, 1058], [812, 1032], [811, 1019], [804, 1019], [806, 964], [731, 965], [706, 966], [710, 981], [706, 1012], [712, 1012], [712, 1049], [726, 1049], [726, 1043], [739, 1043], [739, 1059], [754, 1059], [776, 1052], [778, 1072], [765, 1078], [767, 1085], [776, 1085], [776, 1085], [803, 1085]]]
                }
            }, {
                "type": "Feature",
                "id": "US.NY.109",
                "properties": {
                    "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "us-ny-109", "hc-a2": "TO", "name": "Tompkins", "code": "36109"
                }
                ,
                "geometry": {
                    "type": "Polygon", "coordinates": [[[712, 1049], [703, 1050], [695, 1050], [679, 1051], [681, 1078], [680, 1128], [704, 1129], [697, 1134], [687, 1151], [732, 1151], [732, 1148], [774, 1149], [775, 1110], [776, 1085], [767, 1085], [765, 1078], [778, 1072], [776, 1052], [754, 1059], [739, 1059], [739, 1043], [726, 1043], [726, 1049], [712, 1049]]]
                }
            }]
        }
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/highmaps/highmaps.service.js